import { axiosInstance } from "./client";
import { TranslatableEnum } from "@rumble-it/common-lib/types/models/TranslatableEnum.interface";

export const getDriverTypes = async () =>
  axiosInstance
    .get<TranslatableEnum[]>(`/dossiers/driver-type`)
    .then((response) => response.data);
